export default {
  'actions.title': 'ACCIONES',
  'actions.search': 'Busca una Acción',
  'actions.description.defaultInitial': 'Initial action of the process',
  'actions.description.completeInformation': 'Allows to complete information through forms',
  'config.form.isInitialForm': '¿Formulario Inicial?',
  'config.form.isHeaderDetailsVisible': '¿Detalles de Cabecera Visible?',
  'config.form.isVisibleInDetails': '¿Visible en vista detalle de solicitud?',
  'actions.form.isInitialAction': '¿Acción Inicial?',
  'actions.form.isAutoOpenEditOperationEnabled': '¿Abrir Automáticamente Operación Editar',
  'actions.form.saveButtonDisabled': '¿Ocultar Botón Guardar?',
  'actions.form.emailServerConfiguration': 'Servidor de Correo',

  'actions.form.name': 'Name',
  'actions.form.description': 'Description',
  'actions.form.displayTitle': 'Título a Mostrar',
  'actions.form.enabled': 'Enabled?',
  'actions.form.completeInformationForm': 'Formulario Completar Información',
  'actions.form.nextAction': 'Siguiente Acción',
  'actions.form.form': 'Form',
  'actions.form.field': 'Field',
  'actions.form.users': 'Users',
  'actions.form.positions': 'Positions',
  'actions.form.areas': 'Areas',
  'actions.form.userGroups': 'User Groups',
  'actions.form.aiAgents': 'Agents',
  'actions.form.parentParallelAction': 'Parent Parallel Action',
  'actions.form.parentParallelFlow': 'Parent Parallel Flow',
  'actions.form.parentIterateAction': 'Parent Iterate Action',
  'actions.form.isRejectControlEnabled': '¿Control de Rechazo Habilitado?',
  'actions.form.nextActionIfFalseId': 'Siguiente Acción(No)',
  'actions.form.maxRejectionCount': 'Máximo Número de Rechazos',
  'actions.form.minNumberOfRejections': 'Mínimo Número de Rechazos',
  'actions.form.isTooltipEnabled': '¿Tooltip Habilitado?',
  'actions.form.tooltip': 'Tooltip',
  'actions.form.isPDFGenerationEnabled': '¿Generación de PDF Habilitada?',
  'actions.form.isNotificationsEnabled': '¿Notificaciones Habilitadas?',
  'actions.form.isPDFAttachmentEnabled': '¿Adjuntar PDF en Correos?',
  'actions.form.notificationsFrequency': 'Frecuencia de Notificaciones',
  'actions.form.frequencyValue': 'Valor Frecuencia',
  'actions.form.isWebhookEnabled': '¿Webhook Habilitado?',
  'actions.form.isWebhookCurrentStepValidationEnabled': '¿Validar Paso Actual?',
  'actions.form.isInternalExecutionAllowed': '¿Permitir Ejecución Interna?',
  'actions.form.webhookUser': 'Usuario Operaciones Webhook',
  'actions.form.webApiConnection': 'Conexión API',
  'actions.form.connection': 'API Connection',
  'actions.form.databaseConnection': 'Database Connection',
  'actions.form.reason': 'Reason',
  'actions.form.logicalOperator': 'Logical Operator',
  'actions.form.databaseQuery': 'Consulta Base de Datos',
  'actions.form.dynamicEntity': 'Entidad Dinámica',
  'actions.form.dynamicEntityOperation': 'Operación',
  'actions.form.iterationDataSource': 'Iteration Data Source',
  'actions.form.iterationForm': 'Form',
  'actions.form.iterationTableField': 'Table',
  'actions.form.itemsAffected': 'Items Affected',
  'actions.form.customItemsAffectedNumber': 'Custom Items Count',
  'actions.form.operationEntity': 'Entity',
  'actions.form.operation': 'Operation',
  'actions.form.fileFormat': 'Format',
  'actions.form.textSeparator': 'Separator',
  'actions.form.writeHeader': 'Write Header?',
  'actions.form.readHeader': 'Read Header?',
  'actions.form.xmlWriteDocumentTypeDefinition': 'Write XML DTD?',
  'actions.form.xmlRootTagText': 'Root Tag',
  'actions.form.xmlElementTagText': 'Element Tag',
  'actions.form.documentSourceForm': 'Form',
  'actions.form.documentSourceField': 'Attachment Field',
  'actions.form.startRow': 'Start Row',
  'actions.form.handlerType': 'AI Handler Type',
  'actions.form.reasoningEffort': 'Reasoning Effort',
  'actions.form.reasoningSummary': 'Reasoning Summary',
  'actions.form.agent': 'AI Agent',
  'actions.form.fieldBehavior': 'Behavior',
  'actions.form.command': 'Command',
  'actions.form.commandBehavior': 'Command Behavior',
  'actions.form.order': 'Order',
  'actions.form.fieldType': 'Field Type',
  'actions.form.conditionGroups': 'Conditions (JSON)',

  // DynamicEntityOperation
  'actions.form.select.Search': 'Search',
  'actions.form.select.Add': 'Add',
  'actions.form.select.Modify': 'Modify',
  'actions.form.select.Remove': 'Remove',
  'actions.form.select.Count': 'Count',
  'actions.form.select.Sum': 'Sum',
  'actions.form.select.Subtraction': 'Subtraction',
  'actions.form.select.Increment': 'Increment',
  'actions.form.select.Decrement': 'Decrement',
  'actions.form.select.EvaluateFormula': 'Evaluate Formula',

  // SearchResultGroupingMode
  'actions.form.select.None': 'None',
  'actions.form.select.ResponseMapping': 'Response Mapping',

  // SearchResultAllocationMode
  'actions.form.select.Ordered': 'Ordered',
  'actions.form.select.Random': 'Random',

  // ColumnOrderDirection
  'actions.form.select.Ascending': 'Ascending',
  'actions.form.select.Descending': 'Descending',

  // ItemsAffected
  'actions.form.select.All': 'All',
  'actions.form.select.One': 'One',
  'actions.form.select.Custom': 'Custom',
  'actions.form.select.FormTable': 'Form Table',
  'actions.form.select.DynamicEntity': 'Dynamic Entity',
  'actions.form.select.FormFieldAttachment': 'Field Attachment',
  'actions.form.select.Activate': 'Activate',
  'actions.form.select.Deactivate': 'Deactivate',
  'actions.form.select.CancelDelegation': 'Cancel Delegation',
  'actions.form.select.User': 'User',
  'actions.form.select.Position': 'Position',
  'actions.form.select.Area': 'Area',
  'actions.form.select.UserGroup': 'User Group',
  'actions.form.select.UserGroupUser': 'User Group User',
  'actions.form.select.Environment': 'Environment',
  'actions.form.select.EnvironmentUser': 'Environment User',
  'actions.form.select.Delegation': 'Delegation',
  'actions.form.select.DelegationConfiguration': 'Delegation Configuration',
  'actions.form.select.GlobalEntityApproverByAreas': 'Entity Approvers by Areas',
  'actions.form.select.GlobalEntityApproverByPositions': 'Entity Approvers by Positions',
  'actions.form.select.GlobalEntityApproverByUserGroups': 'Entity Approvers by User Groups',
  'actions.form.select.GlobalEntityApproverUsers': 'Entity Approver Users',
  'actions.form.select.GlobalUserGroupApproverByAreas': 'Group Approvers by Areas',
  'actions.form.select.GlobalUserGroupApproverByPositions': 'Group Approvers by Positions',
  'actions.form.select.GlobalUserGroupApproverUsers': 'Group Approver Users',
  'actions.form.select.ReportTrace': 'Trace Report',
  'actions.form.select.ProcessInstance': 'Process Instance',
  'actions.form.select.ChatThreadParticipant': 'Chat Participant',
  'actions.form.select.Json': 'JSON',
  'actions.form.select.Text': 'Text',
  'actions.form.select.Csv': 'CSV',
  'actions.form.select.Xml': 'XML',
  'actions.form.select.Parquet': 'Parquet',
  'actions.form.select.Agent': 'Agent',
  'actions.form.select.Responses': 'Responses',
  'actions.form.select.Parser': 'Parser',
  'actions.form.select.Generic': 'Generic',
  'actions.form.select.Concise': 'Concise',
  'actions.form.select.Detailed': 'Detailed',
  'actions.form.select.Auto': 'Auto',
  'actions.form.select.Minimal': 'Minimal',
  'actions.form.select.Low': 'Low',
  'actions.form.select.Medium': 'Medium',
  'actions.form.select.High': 'High',
  'actions.form.select.ReadOnly': 'Read Only',
  'actions.form.select.Hidden': 'Hidden',
  'actions.form.select.Visible': 'Visible',
  'actions.form.select.Required': 'Required',
  'actions.form.select.NotRequired': 'Not Required',
  'actions.form.select.VisibleAndSkipFormulaEvaluation': 'Visible, Skip Formula',
  'actions.form.select.HiddenAndSkipFormulaEvaluation': 'Hidden, Skip Formula',
  'actions.form.select.Locked': 'Locked',
  'actions.form.select.Edit': 'Edit',
  'actions.form.select.Delete': 'Delete',
  'actions.form.select.Import': 'Import',
  'actions.form.select.Export': 'Export',
  'actions.form.select.Clear': 'Clear',
  'actions.form.select.Allow': 'Allow',
  'actions.form.select.Denied': 'Denied',

  'actions.config.configurations': 'Configurations',
  'actions.config.approval': 'Approval',
  'actions.config.action-approval-general': 'General',
  'actions.config.action-approval-rejection': 'Rejection',
  'actions.config.action-approval-deadline': 'Deadline',
  'actions.config.action-approval-filters': 'Filters',
  'actions.config.action-approval-filters-general': 'General',
  'actions.config.action-approval-filters-users': 'Users',
  'actions.config.action-approval-filters-positions': 'Positions',
  'actions.config.action-approval-filters-areas': 'Areas',
  'actions.config.action-approval-filters-user-groups': 'User Groups',
  'actions.config.action-approval-filters-external-users': 'External Users',
  'actions.config.action-approval-filters-agents': 'Agents',
  'actions.config.action-approval-filters-user-extra-fields': 'User Extra Fields',
  'actions.config.action-approval-filters-global-approvers': 'Global Approver Filters',
  'actions.config.action-approval-filters-form-field-user-approvers': 'Form Field Filters',
  'actions.config.custom-notifications': 'Custom Notifications',
  'actions.config.notifications-mapping-attachments': 'Notificaciones / Mapeos Adjuntos',
  'actions.config.email-template': 'Formato de Correo',
  'actions.config.pdf-template-generation-mapping': 'Mapeos Generación Formatos',
  'actions.config.form-complete-information': 'Complete Information Form',
  'actions.config.digital-signature-field-mapping': 'Digital Signature Field Mapping',
  'actions.config.response-status': 'Mapeo Código Respuesta Http / Acción Siguiente',
  'actions.config.api-call-send': 'Mapeos Envío API',
  'actions.config.api-call-response': 'Mapeos Respuesta API',
  'actions.config.webhook-mapping': 'Mapeos Parámetros Webhook',
  'actions.config.set-variable': 'Establecer Variables',
  'actions.config.set-form-field-value': 'Establecer Datos de Formularios',
  'actions.config.conditional': 'Conditional',
  'actions.config.action-entity-operation': 'Entity Operation',
  'actions.config.action-scheduled-execution': 'Scheduling',
  'actions.config.action-webhook-general': 'Webhook (General)',
  'actions.config.action-behaviors': 'Behaviors',
  'actions.config.set-form-data': 'Set Form Data',
  'actions.config.action-iteration': 'Iteration',
  'actions.config.action-internal-operation': 'Internal Operation',
  'actions.config.action-generate-plain-text-file': 'File Format',
  'actions.config.action-import-plain-text-file': 'File Format',
  'actions.config.action-automy-ai': 'AI Operation',
  'actions.config.action-behaviors-fields': 'Behaviors - Fields',
  'actions.config.action-behaviors-commands': 'Behaviors - Commands',
  'actions.config.action-webhook-general': 'Webhook (General)',
  'actions.config.action-behaviors': 'Behaviors',
  'actions.config.set-form-data': 'Set Form Data',
  'actions.config.action-iteration': 'Iteration',
  'actions.config.action-internal-operation': 'Internal Operation',
  'actions.config.action-generate-plain-text-file': 'File Format',
  'actions.config.action-import-plain-text-file': 'File Format',
  'actions.config.action-automy-ai': 'AI Operation',

  'actions.form.minimumNumberOfApprovers': 'Minimum Number of Approvers',
  'actions.form.isRejectionDisabled': 'Disable Rejection?',
  'actions.form.isCompletedOptionDisabled': 'Disable Complete Button?',
  'actions.form.allowedAppClient': 'Allowed Application',
  'actions.form.webhookToken': 'Webhook Url',

  'actions.form.isErrorControlEnabled': '¿Habilitar Control de Errores?',
  'actions.form.nextActionIfErrorId': 'Siguiente Acción (Error)',
  'actions.form.errorValueDestination': 'Destino Error',
  'actions.form.errorVariableDestinationId': 'Error - Variable Destino',
  'actions.form.errorFormDestinationId': 'Error - Formulario Destino',
  'actions.form.errorFieldDestinationId': 'Error - Campo Destino',

  'actions.form.filtersLogicalOperator': 'Operador Lógico para Filtros',
  'actions.form.filtersUserGroupsLogicalOperator': 'Operador Lógico para Grupos',

  'actions.form.isDeadlineEnabled': '¿Habilitar Control de Límite de Tiempo de Ejecución?',
  'actions.form.deadlineMeasureUnit': 'Unidad de Control de Tiempo',
  'actions.form.deadlineMeasureValue': 'Valor de Control de Tiempo',
  'actions.form.overdueOperation': 'Operación',
  'actions.form.nextActionIfOverdueId': 'Acción Siguiente',
  'actions.form.overdueOperationObservations': 'Observaciones',

  'actions.form.isTwoFactorApprovalEnabled': '¿Aprobación Two-Factor?',
  'actions.form.isForApplicantApprovalEnabled': '¿Aprobar por el Solicitante?',
  'actions.form.isApprovalByExternalUserEnabled': '¿Habilitar Aprobación por Usuario Externo?',
  'actions.form.isPositionEqualToApplicantPosition': '¿Filtrar por Puesto del Solicitante?',
  'actions.form.isAreaEqualToApplicantArea': '¿Filtrar por Área del Solicitante?',
  'actions.form.isForApplicantBossApprovalEnabled': '¿Aprobar por el Jefe del Solicitante?',
  'actions.form.isApproveByTheLastApproverEnabled': '¿Aprobar por Último Aprobador?',
  'actions.form.isApproveByTheLastRejectionUserEnabled': '¿Aprobar por Último Rechazador?',
  'actions.form.isApproveByTheLastRevisionUserEnabled': '¿Aprobar por Último Revisor?',

  'actions.form.isGlobalUserGroupApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Grupos de Usuarios?',
  'actions.form.globalUserGroupFilterFormId':
    'Formulario para Filtro Global de Aprobadores por Grupos de Usuarios',
  'actions.form.globalUserGroupFilterFieldId':
    'Campo para Filtro Global de Aprobadores por Grupos de Usuarios',
  'actions.form.isGlobalUserGroupApproversFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Grupos de Usuarios?',
  'actions.form.globalUserGroupApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Grupos de Usuarios',

  'actions.form.isGlobalUserGroupPositionApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Grupos de Usuarios y Puestos?',
  'actions.form.globalUserGroupFilterPositionFormId':
    'Formulario para Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',
  'actions.form.globalUserGroupFilterPositionFieldId':
    'Campo para Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',
  'actions.form.isGlobalUserGroupPositionApproversFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Puestos?',
  'actions.form.globalUserGroupPositionApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Grupos de Usuarios y Puestos',

  'actions.form.isGlobalUserGroupAreaApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Grupos de Usuarios y Áreas?',
  'actions.form.globalUserGroupFilterAreaFormId':
    'Formulario para Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',
  'actions.form.globalUserGroupFilterAreaFieldId':
    'Campo para Filtro Global de Aprobadores por Grupos de Usuarios y Áreas',
  'actions.form.IsGlobalEntityApproversByAreaFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Áreas?',
  'actions.form.globalEntityApproversByAreaFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Áreas',

  'actions.form.isGlobalEntityApproversFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Usuarios?',
  'actions.form.globalEntityFilterFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades',
  'actions.form.globalEntityFilterFieldId': 'Campo para Filtro Global de Aprobadores por Entidades',
  'actions.form.isGlobalEntityApproversFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades?',
  'actions.form.globalEntityApproversFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades',

  'actions.form.isGlobalEntityApproversByUserGroupFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Grupos de Usuarios?',
  'actions.form.globalEntityFilterByUserGroupFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',
  'actions.form.globalEntityFilterByUserGroupFieldId':
    'Campo para Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',
  'actions.form.isGlobalEntityApproversByUserGroupFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Grupos de Usuarios?',
  'actions.form.globalEntityApproversByUserGroupFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Grupos de Usuarios',

  'actions.form.isGlobalEntityApproversByPositionFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Puestos?',
  'actions.form.globalEntityFilterByPositionFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades y Puestos',
  'actions.form.globalEntityFilterByPositionFieldId':
    'Campo para Filtro Global de Aprobadores por Entidades y Puestos',
  'actions.form.isGlobalEntityApproversByPositionFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Puestos?',
  'actions.form.globalEntityApproversByPositionFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Puestos',

  'actions.form.isGlobalEntityApproversByAreaFilterEnabled':
    '¿Habilitar Filtro Global de Aprobadores por Entidades y Áreas?',
  'actions.form.globalEntityFilterByAreaFormId':
    'Formulario para Filtro Global de Aprobadores por Entidades y Áreas',
  'actions.form.globalEntityFilterByAreaFieldId':
    'Campo para Filtro Global de Aprobadores por Entidades y Áreas',
  'actions.form.IsGlobalEntityApproversByAreaFilterApprovalLevelEnabled':
    '¿Habilitar Nivel de Filtro Global de Aprobadores por Entidades y Áreas?',
  'actions.form.globalEntityApproversByAreaFilterApprovalLevel':
    'Nivel de Filtro Global de Aprobadores por Entidades y Áreas',

  'actions.form.isApproverByUserFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo de Formulario?',
  'actions.form.approverByUserFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo de Formulario',
  'actions.form.approverByUserFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo de Formulario',

  'actions.form.isApproverByPositionFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo Puesto de Formulario?',
  'actions.form.approverByPositionFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo Puesto de Formulario',
  'actions.form.approverByPositionFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo Puesto de Formulario',

  'actions.form.isApproverByAreaFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo Área de Formulario?',
  'actions.form.approverByAreaFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo Área de Formulario',
  'actions.form.approverByAreaFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo Área de Formulario',

  'actions.form.isApproverByUserGroupFormFieldFilterEnabled':
    '¿Habilitar Filtro de Usuario por Campo Grupo de Usuarios de Formulario?',
  'actions.form.approverByUserGroupFormFieldFormId':
    'Formulario para Filtro de Usuario por Campo Grupo de Usuarios de Formulario',
  'actions.form.approverByUserGroupFormFieldFieldId':
    'Campo para Filtro de Usuario por Campo Grupo de Usuarios de Formulario',

  'action.config.select.ReadOnly': 'Read Only',
  'action.config.select.Hidden': 'Hidden',
  'action.config.select.Visible': 'Visible',
  'action.config.select.Required': 'Required',
  'action.config.select.NotRequired': 'Not Required',
  'action.config.select.VisibleAndSkipFormulaEvaluation': 'Visible and Skip Formula Evaluation',
  'action.config.select.HiddenAndSkipFormulaEvaluation': 'Hidden and Skip Formula Evaluation',

  'action.config.select.formField': 'Formulario / Campo',
  'action.config.select.variable': 'Variable',

  'action.config.select.And': 'AND',
  'action.config.select.Or': 'OR',

  'action.config.select.rejectRequest': 'Rechazar Solicitud',
  'action.config.select.cancelarSolicitud': 'Cancelar Solicitud',
  'action.config.select.executeAction': 'Ejecutar Acción',
  'action.generate.ai.coming.soon': 'Generate AI Coming Soon',
  'action.Enter.some.text.here': 'Enter some text here...',
  'action.config.beautify': 'Beautify',
  'action.config.beautify.loading.title': 'Polishing your diagram',
  'action.config.beautify.loading.subtitle':
    'We are arranging every step and connection so the workflow looks stunning. This will only take a moment.',
  'action.config.diagram.loading.title': 'Loading the diagram',
  'action.config.diagram.loading.subtitle':
    'We are bringing every action and connection onto the canvas with perfect clarity.',

  // New fields for all ActionTypes
  'actions.form.process': 'Process',
  'actions.form.actionToExecute': 'Action to Execute',
  'actions.form.sequence': 'Sequence',
  'actions.form.rpaAgent': 'RPA Agent',
  'actions.form.rpaFlow': 'RPA Flow',
  'actions.form.integration': 'Integration',
  'actions.form.integrationFunction': 'Function',
  'actions.form.operationType': 'Operation Type',
  'actions.form.model': 'Model',
  'actions.form.serviceType': 'Service Type',
  'actions.form.sharePointOperation': 'Operation Type',
  'actions.form.ftpOperationType': 'Operation Type',
  'actions.form.programmingLanguage': 'Language',
  'actions.form.whatsAppBusinessOperationType': 'Operation Type',

  // DynamicEntityOperation fields
  'actions.form.dynamicEntity': 'Dynamic Entity',
  'actions.form.dynamicEntityOperation': 'Operation Type',
  'actions.form.searchResultGroupingMode': 'Grouping Mode',
  'actions.form.searchResultAllocationMode': 'Allocation Mode',
  'actions.form.sortField': 'Sort Field',
  'actions.form.sortDirection': 'Sort Direction',
  'actions.form.itemsAffected': 'Items Affected',
  'actions.form.customItemsAffectedNumber': 'Custom Items Number',

  // ScheduledExecution fields
  'actions.form.scheduledExecutionType': 'Scheduled Execution Type',
  'actions.form.delayFrequency': 'Delay Frequency',
  'actions.form.delayFrequencyValue': 'Delay Frequency Value',
  'actions.form.executionHour': 'Execution Hour',
  'actions.form.executionDayOfWeek': 'Day of the Week',
  'actions.form.executionMonth': 'Execution Month',
  'actions.form.executionMonthDay': 'Day of the Month',
  'actions.form.delayUntilFieldValueForm': 'Delay / Form',
  'actions.form.delayUntilFieldValueField': 'Delay / Field',
  'actions.form.delayUntilVariableValueVariable': 'Delay / Variable',

  // ActionScheduledExecutionType
  'actions.form.select.Delay': 'Delay',
  'actions.form.select.DelayUntil': 'Delay Until',
  'actions.form.select.DelayUntilFieldValue': 'Delay Until Field Value',
  'actions.form.select.DelayUntilVariableValue': 'Delay Until Variable Value',

  // Validation messages for scheduled execution
  'actions.validation.integerMinValue': 'Must be an integer greater than or equal to {min}',
  'actions.validation.integerRange': 'Must be an integer between {min} and {max}',

  // FrequencyUnit
  'actions.form.select.Minute': 'Minute',
  'actions.form.select.Hour': 'Hour',
  'actions.form.select.Day': 'Day',
  'actions.form.select.Month': 'Month',

  // DayOfWeek
  'actions.form.select.Sunday': 'Sunday',
  'actions.form.select.Monday': 'Monday',
  'actions.form.select.Tuesday': 'Tuesday',
  'actions.form.select.Wednesday': 'Wednesday',
  'actions.form.select.Thursday': 'Thursday',
  'actions.form.select.Friday': 'Friday',
  'actions.form.select.Saturday': 'Saturday',
  'actions.form.select.Weekend': 'Weekend',
  'actions.form.select.Weekday': 'Weekday',

  // MonthName
  'actions.form.select.January': 'January',
  'actions.form.select.February': 'February',
  'actions.form.select.March': 'March',
  'actions.form.select.April': 'April',
  'actions.form.select.May': 'May',
  'actions.form.select.June': 'June',
  'actions.form.select.July': 'July',
  'actions.form.select.August': 'August',
  'actions.form.select.September': 'September',
  'actions.form.select.October': 'October',
  'actions.form.select.November': 'November',
  'actions.form.select.December': 'December',

  // ActionOverdueOperation
  'actions.form.select.RejectProcessInstance': 'Reject Process Instance',
  'actions.form.select.CancelProcessInstance': 'Cancel Process Instance',
  'actions.form.select.ExecuteAction': 'Execute Action',

  // ExternalUserValueSource
  'actions.form.select.FormField': 'Form Field',
  'actions.form.select.Variable': 'Variable',
  'actions.form.select.FixedValue': 'Fixed Value',

  // Approval - General
  'actions.form.minApproversCount': 'Minimum Number of Approvers',
  'actions.form.twoFactorApprovalEnabled': 'Two-Factor Approval?',

  // Approval - Rejection
  'actions.form.disableReject': 'Disable Reject?',
  'actions.form.controlRejection': 'Rejection Control?',
  'actions.form.minRejectionCount': 'Minimum Rejection Count',
  'actions.form.maxRejectionCount': 'Maximum Rejection Count',

  // Approval - Deadline
  'actions.form.enabled': 'Enable?',
  'actions.form.delayType': 'Scheduled Execution Type',
  'actions.form.measureUnit': 'Delay Frequency',
  'actions.form.measureValue': 'Delay Frequency Value',
  'actions.form.delayHour': 'Execution Hour',
  'actions.form.delayDayOfWeek': 'Day of the Week',
  'actions.form.delayMonthDay': 'Month Day',
  'actions.form.delayMonth': 'Execution Month',
  'actions.form.delayUntilFieldValueForm': 'Delay / Form',
  'actions.form.delayUntilFieldValueField': 'Delay / Field',
  'actions.form.delayUntilVariableValueVariable': 'Delay / Variable',

  // Approval - Filters General
  'actions.form.applicantApprovalEnabled': 'Approve by Applicant?',
  'actions.form.approveByApplicantBoss': 'Approve by Applicant Boss?',
  'actions.form.approveByLastApprover': 'Approve by Last Approver?',
  'actions.form.approveByLastRejectionUser': 'Approve by Last Rejection User?',
  'actions.form.approveByLastRevisionUser': 'Approve by Last Revision User?',
  'actions.form.filterByApplicantPosition': 'Filter by Applicant Position?',
  'actions.form.filterByApplicantArea': 'Filter by Applicant Area?',
  'actions.form.filterByApplicantUserGroups': 'Filter by Applicant User Groups?',
  'actions.form.allowExternalUserApproval': 'Allow External User Approval?',

  // Approval - Filters (Lists)
  'actions.form.users': 'Users',
  'actions.form.positions': 'Positions',
  'actions.form.areas': 'Areas',
  'actions.form.userGroups': 'User Groups',
  'actions.form.aiAgents': 'Agents',

  // External Users
  'actions.form.valueSource': 'Source',
  'actions.form.sourceForm': 'Form',
  'actions.form.sourceField': 'Field',
  'actions.form.sourceVariable': 'Variable',
  'actions.form.fixedValue': 'Fixed Value',

  // User Extra Fields
  'actions.form.userExtraField': 'Extra Field',
  'actions.form.filterValue': 'Filter Value',

  // Global Approvers
  'actions.form.userGroupApprovers': 'Global Filter Approvers by User Groups',
  'actions.form.userGroupPositionApprovers': 'Global Filter Approvers by User Groups and Positions',
  'actions.form.userGroupAreaApprovers': 'Global Filter Approvers by User Groups and Areas',
  'actions.form.entityUsersApprovers': 'Global Filter Approvers by Entities and Users',
  'actions.form.entityPositionUsersApprovers': 'Global Filter Approvers by Entities and Positions',
  'actions.form.entityAreaUsersApprovers': 'Global Filter Approvers by Entities and Areas',
  'actions.form.entityUserGroupUsersApprovers':
    'Global Filter Approvers by Entities and User Groups',
  'actions.form.approvalLevelEnabled': 'Enable Filter Level?',
  'actions.form.approvalLevel': 'Filter Level',
  'actions.form.field': 'Field',

  // Form Field User Approvers
  'actions.form.userApprovers': 'User Filter by Form Field',
  'actions.form.positionApprovers': 'User Filter by Position Form Field',
  'actions.form.areaApprovers': 'User Filter by Area Form Field',
  'actions.form.userGroupApprovers': 'User Filter by User Group Form Field',

  // LogicalOperator
  'actions.form.select.Or': 'Or',
  'actions.form.select.And': 'And',
  'action.canvas.zoomIn': 'Zoom in',
  'action.canvas.pan': 'Pan canvas',
  'action.canvas.select': 'Select nodes',
  'action.canvas.zoomLabel': 'Zoom',
};
